module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [(_vm.getRoleType === 99) ? _c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-10 flex align-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.goBackInfo.name,
        params: _vm.goBackInfo.params,
        query: _vm.goBackInfo.query
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default m-r-5 flex"
  }, [_c('span', [_vm._v("返回")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.title)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.subtitle)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex grey darken-1"
  }, [(_vm.brand.name || _vm.store.brand_name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s(_vm.brand.name ? _vm.brand.name : _vm.store.brand_name ? _vm.store.brand_name : '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s('/')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.store.name)
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('li', {
    class: {
      'active': _vm.tab == 1
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.updateQuery(1)
      }
    }
  }, [_c('a', [_vm._v("商品")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tab == 3
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.updateQuery(3)
      }
    }
  }, [_c('a', [_vm._v("套餐")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tab == 10
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.updateQuery(10)
      }
    }
  }, [_c('a', [_vm._v("分類")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-t-10"
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title",
    on: {
      "click": function($event) {
        return _vm.crElement()
      }
    }
  }, [_vm._v("新增" + _vm._s(_vm.tabName) + "別名/描述/警示")])]), _vm._v(" "), _c('div', {
    staticClass: "p-t-50 m-t-15"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-2 bg-light-gray text-left"
  }, _vm._l((_vm.subMenuList), function(option) {
    return _c('div', {
      key: ("option-" + (option.value)),
      staticClass: "select-element",
      class: {
        'active': _vm.subMenu === option.value
      },
      attrs: {
        "disabled": _vm.subMenu === option.value
      },
      on: {
        "click": function($event) {
          return _vm.clickSubMenu(option.value)
        }
      }
    }, [_c('span', {
      staticClass: "text-w-600 p-x-15"
    }, [_vm._v(_vm._s(option.text))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-10 p-l-10"
  }, [_c('div', {
    staticClass: "flex justify-between"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchType),
      expression: "searchType"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "name"
    }
  }, [_vm._v("商品名稱")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "id"
    }
  }, [_vm._v("商品料號")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": _vm.search
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-center title"
  }, [_vm._v(_vm._s(_vm.subMenu === 'alias' ? '商品別名' : '商品描述/警語'))]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [(_vm.getRoleType !== 10 || _vm.getStores.length > 1) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": !_vm.selectItems.length,
      "data-toggle": "modal",
      "data-target": "#copyModal"
    }
  }, [_vm._v("\n                    複製選取設定至其他店家\n                  ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": !_vm.selectItems.length,
      "data-toggle": "modal",
      "data-target": "#delDesAlisModal"
    },
    on: {
      "click": _vm.setDeleteItem
    }
  }, [_vm._v("\n                    批次刪除\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('prod-setting-table', {
    attrs: {
      "setting-list": _vm.list,
      "search-text": _vm.searchText,
      "meta": _vm.meta,
      "tab": _vm.tab,
      "type": _vm.subMenu,
      "tableIndex": _vm.page
    },
    on: {
      "update:settingList": function($event) {
        _vm.list = $event
      },
      "update:setting-list": function($event) {
        _vm.list = $event
      },
      "update:tableIndex": function($event) {
        _vm.page = $event
      },
      "update:table-index": function($event) {
        _vm.page = $event
      },
      "updatePagination": _vm.updatePagination,
      "updateDel": _vm.updateDelElement,
      "selectItem": _vm.setSelectItem
    }
  })], 1)])])])])])]), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delDesAlisOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('choose-store-modal', {
    attrs: {
      "option": _vm.storeOption
    },
    on: {
      "copyStore": _vm.copyStore
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-808fbbd8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/ProductSetting.vue
// module id = 2503
// module chunks = 1